var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPaypal = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65.809,
    height: 17.536,
    viewBox: "0 0 65.809 17.536",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "paypal",
    transform: "translate(-26.69 -5.051)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_163",
    "data-name": "Trazado 163",
    d: "M43.557,6.749H38.438a.711.711,0,0,0-.7.6l-2.07,13.126a.426.426,0,0,0,.422.492h2.444a.711.711,0,0,0,.7-.6l.558-3.54a.71.71,0,0,1,.7-.6h1.62c3.372,0,5.318-1.632,5.826-4.865a3.943,3.943,0,0,0-.653-3.3A4.749,4.749,0,0,0,43.557,6.749Zm.591,4.794c-.28,1.837-1.683,1.837-3.04,1.837h-.772l.542-3.43a.426.426,0,0,1,.421-.36h.354c.924,0,1.8,0,2.247.527A1.706,1.706,0,0,1,44.147,11.543Z",
    transform: "translate(-8.97 -1.698)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_164",
    "data-name": "Trazado 164",
    d: "M62.758,13H60.306a.427.427,0,0,0-.421.36l-.109.686-.171-.248a3.489,3.489,0,0,0-2.9-1.028A5.637,5.637,0,0,0,51.237,17.7a4.627,4.627,0,0,0,.913,3.766,3.835,3.835,0,0,0,3.087,1.247,4.69,4.69,0,0,0,3.393-1.4l-.109.681a.426.426,0,0,0,.421.494H61.15a.711.711,0,0,0,.7-.6l1.325-8.389A.425.425,0,0,0,62.758,13Zm-3.417,4.771a2.732,2.732,0,0,1-2.766,2.34,1.9,1.9,0,0,1-2.031-2.383,2.744,2.744,0,0,1,2.747-2.359,2.068,2.068,0,0,1,1.635.668A2.122,2.122,0,0,1,59.341,17.768Z",
    transform: "translate(-12.87 -3.211)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_165",
    "data-name": "Trazado 165",
    d: "M80.258,13.075H77.795a.714.714,0,0,0-.589.312l-3.4,5-1.44-4.809a.713.713,0,0,0-.683-.507H69.265a.427.427,0,0,0-.4.564L71.573,21.6l-2.551,3.6a.426.426,0,0,0,.348.674h2.46a.71.71,0,0,0,.585-.305l8.193-11.826A.426.426,0,0,0,80.258,13.075Z",
    transform: "translate(-17.315 -3.289)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_166",
    "data-name": "Trazado 166",
    d: "M92.338,6.749H87.218a.711.711,0,0,0-.7.6l-2.07,13.126a.426.426,0,0,0,.421.492h2.627a.5.5,0,0,0,.491-.421l.588-3.721a.71.71,0,0,1,.7-.6h1.62c3.373,0,5.318-1.632,5.827-4.865a3.94,3.94,0,0,0-.653-3.3A4.744,4.744,0,0,0,92.338,6.749Zm.591,4.794c-.279,1.837-1.683,1.837-3.04,1.837h-.772l.543-3.43a.425.425,0,0,1,.421-.36h.354c.924,0,1.8,0,2.247.527A1.706,1.706,0,0,1,92.928,11.543Z",
    transform: "translate(-21.24 -1.698)",
    fill: "#179bd7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_167",
    "data-name": "Trazado 167",
    d: "M111.539,13h-2.45a.424.424,0,0,0-.421.36l-.109.686-.172-.248a3.487,3.487,0,0,0-2.894-1.028,5.636,5.636,0,0,0-5.472,4.929,4.629,4.629,0,0,0,.912,3.766,3.837,3.837,0,0,0,3.087,1.247,4.69,4.69,0,0,0,3.393-1.4l-.109.681a.427.427,0,0,0,.422.494h2.207a.711.711,0,0,0,.7-.6l1.326-8.389A.427.427,0,0,0,111.539,13Zm-3.417,4.771a2.731,2.731,0,0,1-2.766,2.34,1.9,1.9,0,0,1-2.031-2.383,2.745,2.745,0,0,1,2.747-2.359,2.068,2.068,0,0,1,1.635.668A2.111,2.111,0,0,1,108.122,17.768Z",
    transform: "translate(-25.141 -3.211)",
    fill: "#179bd7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_168",
    "data-name": "Trazado 168",
    d: "M118.587,7.109l-2.1,13.366a.426.426,0,0,0,.421.492h2.112a.71.71,0,0,0,.7-.6l2.072-13.125a.426.426,0,0,0-.421-.493h-2.365A.428.428,0,0,0,118.587,7.109Z",
    transform: "translate(-29.3 -1.697)",
    fill: "#179bd7"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPaypal);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/paypal.a5c5f12ca62e35b6fa3c64e09748462b.svg";